import { HTTP } from '../../utils'

export const populateMajors = () => {
  return HTTP().get('majorMinor/institution/MAJOR')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const populateMinors = () => {
  return HTTP().get('majorMinor/institution/MINOR')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const populateCareers = () => {
  return HTTP().get('career/all')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const populateIndustries = () => {
  return HTTP().get('industry/all')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getReport = (query) => {
  return HTTP().get('/reports/alumni?' + query)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getAlumniReport = (title) => {
  return HTTP().get('/reports/alumni?reportName=' + title)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getMajorInformation = (major) => {
  return HTTP().get('majorMinor/information?name=' + major)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getCareerInformation = (career, institutionId) => {
  return HTTP().get('career/information/' + career + '/' + institutionId)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getCareerResults = (cipCode) => {
  return HTTP().get('majorMinor/careers/' + cipCode)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getProgramResults = (cipCode) => {
  return HTTP().get('majorMinor/relatedPrograms/' + cipCode)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getCareerResultsUsingSocCode = (socCode) => {
  return HTTP().get('career/relatedCareers/' + socCode)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getProgramResultsUsingSocCode = (socCode) => {
  return HTTP().get('career/programs/' + socCode)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getAllBookmarks = () => {
  let url = 'bookmark/user/all'
  return HTTP().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getBookmarks = (name, page, count) => {
  return HTTP().get('bookmark/user?name=' + name + '&page=' + page + '&count=' + count)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const createBookmark = (bookmark) => {
  return HTTP().put('bookmark', bookmark)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const deleteBookmark = (uuid) => {
  var url = '/bookmark/' + uuid
  return HTTP().delete(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getCareerUsingUuid = (uuid) => {
  var url = '/career/' + uuid
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getProgramGuideUsingUuid = (uuid) => {
  var url = '/programguide/' + uuid
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getMajorMinorUsingUuid = (uuid) => {
  var url = '/majorMinor/' + uuid
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getExploreSubstreamEntities = (streamUuid) => {
  if (!streamUuid) {
    return {}
  }
  let url = '/entity/exploreSubstreamEntities/' + streamUuid
  return HTTP().get(url)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
}

export const deleteSubstreamEntity = (streamUuid, entityUuid) => {
  if (!streamUuid || !entityUuid) {
    return
  }
  let config = {
    headers: {
      'Content-Type': 'application/json'
    }
  }
  let url = '/entity/removeFromExplore/' + streamUuid
  return HTTP().post(url, entityUuid, config)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
}

export const addSubstreamEntity = (streamUuid, entity) => {
  console.log('in addSubstreamEntity streamUuid and entity: ', streamUuid, entity)
  if (!streamUuid || !entity.uuid) {
    return
  }
  let url = '/entity/addToExplore/' + streamUuid
  return HTTP().post(url, entity)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
}

export const logExploreActivity = (activity) => {
  let config = {
    headers: {
      'Content-Type': 'application/json'
    }
  }
  return HTTP().put('entity/log/', JSON.stringify(activity), config)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getProgramCreditProgress = (streamId, programId, recalculate) => {
  var url = '/progress/credit/' + streamId + '/' + programId
  if (recalculate) {
    url += '/update'
  }
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    return e.response
  })
}

export const getCareerSkillProgress = (streamId, careerId, recalculate) => {
  var url = '/progress/skill/' + streamId + '/' + careerId
  if (recalculate) {
    url += '/update'
  }
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getFastestGrowingCareers = () => {
  var url = '/career/fastestGrowingCareers?count=5'
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getCareersWithLargestEmployment = () => {
  var url = '/career/careersWithLargestEmployment?count=5'
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getAllProgramCreditProgress = () => {
  return HTTP().get('progress/all')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getInstitutionCareers = () => {
  return HTTP().get('institutionCareer/all')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const getRecommendedCareers = () => {
  return HTTP().get('custom/recommendedcareers')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}



// WEBPACK FOOTER //
// ./src/app/explore/api.js